import ReactApexChart from "react-apexcharts";

const useDashboardApexChart = () => {

    let createChart = (chartColor, chartData = []) => {
        let currentYear = new Date().getFullYear();

        let series = [
            {
                name: "series1",
                data: chartData.length ? chartData : [0],
            },
        ];

        var options = {
            chart: {
                type: "area",
                width: 80,
                height: 42,
                sparkline: {
                    enabled: true, // Remove whitespace
                },

                toolbar: {
                    show: false,
                },
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "smooth",
                width: 2,
                colors: [chartColor],
                lineCap: "round",
            },
            grid: {
                show: true,
                borderColor: "transparent",
                strokeDashArray: 0,
                position: "back",
                xaxis: {
                    lines: {
                        show: false,
                    },
                },
                yaxis: {
                    lines: {
                        show: false,
                    },
                },
                row: {
                    colors: undefined,
                    opacity: 0.5,
                },
                column: {
                    colors: undefined,
                    opacity: 0.5,
                },
                padding: {
                    top: -3,
                    right: 0,
                    bottom: 0,
                    left: 0,
                },
            },
            fill: {
                type: "gradient",
                colors: [chartColor], // Set the starting color (top color) here
                gradient: {
                    shade: "light", // Gradient shading type
                    type: "vertical", // Gradient direction (vertical)
                    shadeIntensity: 0.5, // Intensity of the gradient shading
                    gradientToColors: [`${chartColor}00`], // Bottom gradient color (with transparency)
                    inverseColors: false, // Do not invert colors
                    opacityFrom: 0.75, // Starting opacity
                    opacityTo: 0.3, // Ending opacity
                    stops: [0, 100],
                },
            },
            // Customize the circle marker color on hover
            markers: {
                colors: [chartColor],
                strokeWidth: 2,
                size: 0,
                hover: {
                    size: 8,
                },
            },
            xaxis: {
                labels: {
                    show: false,
                },
                categories: [
                    `Jan ${currentYear}`,
                    `Feb ${currentYear}`,
                    `Mar ${currentYear}`,
                    `Apr ${currentYear}`,
                    `May ${currentYear}`,
                    `Jun ${currentYear}`,
                    `Jul ${currentYear}`,
                    `Aug ${currentYear}`,
                    `Sep ${currentYear}`,
                    `Oct ${currentYear}`,
                    `Nov ${currentYear}`,
                    `Dec ${currentYear}`,
                ],
                tooltip: {
                    enabled: false,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                },
            },
            tooltip: {
                x: {
                    format: "dd/MM/yy HH:mm",
                },
            },
        };

        return (
            <ReactApexChart
                options={options}
                series={series}
                type='area'
                height={42}
                width={80}
            />
        );
    };

    let createChartTwo = (chartColor, height, data = [], categories = []) => {
        let series = [
            {
                name: "This Month",
                data: data,
            },
        ];

        let options = {
            chart: {
                type: "area",
                width: "100%",
                height: height,
                sparkline: { enabled: false },
                toolbar: { show: false },
                padding: { left: 0, right: 0, top: 0, bottom: 0 },
            },
            dataLabels: { enabled: false },
            stroke: { curve: "smooth", width: 4, colors: [chartColor], lineCap: "round" },
            grid: {
                show: true,
                borderColor: "red",
                strokeDashArray: 0,
                position: "back",
                xaxis: { lines: { show: false } },
                yaxis: { lines: { show: false } },
                padding: { top: -30, right: 0, bottom: -10, left: 0 },
            },
            fill: {
                type: "gradient",
                colors: [chartColor],
                gradient: {
                    shade: "light",
                    type: "vertical",
                    shadeIntensity: 0.5,
                    gradientToColors: [`${chartColor}00`],
                    opacityFrom: 0.6,
                    opacityTo: 0.3,
                    stops: [0, 100],
                },
            },
            markers: { colors: [chartColor], strokeWidth: 3, size: 0, hover: { size: 10 } },
            xaxis: {
                categories: categories, // dynamic last 30 days
                tooltip: { enabled: false },
                labels: {
                    rotate: -45,
                    style: { fontSize: "12px" },
                },
                tickAmount: 10, // reduce number of labels to avoid clutter
            },
            yaxis: { labels: { show: false } },
            tooltip: { x: { format: "dd/MM/yy" } },
        };

        return <ReactApexChart options={options} series={series} type="area" height={height} />;
    };

    let createChartSix = (
        color1,
        color2,
        newEventData = [],
        acceptEventData = [],
        xAxisLabels = [] // new parameter
    ) => {
        let series = [
            {
                name: "Sales",
                data: newEventData.length ? newEventData : [48, 35, 55, 32, 48, 30, 55, 50, 57],
            },
            {
                name: "Expenses",
                data: acceptEventData.length ? acceptEventData : [12, 20, 15, 26, 22, 60, 40, 48, 25],
            },
        ];


        let options = {
            legend: {
                show: false,
            },
            chart: {
                type: "area",
                width: "100%",
                height: 270,
                toolbar: {
                    show: false,
                },
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "smooth",
                width: 3,
                colors: [color1, color2],
                lineCap: "round",
            },
            grid: {
                show: true,
                borderColor: "#D1D5DB",
                strokeDashArray: 1,
                position: "back",
                xaxis: {
                    lines: { show: false },
                },
                yaxis: {
                    lines: { show: true },
                },
                row: { colors: undefined, opacity: 0.5 },
                column: { colors: undefined, opacity: 0.5 },
                padding: { top: -20, right: 10, bottom: -10, left: 0 },
            },
            fill: {
                type: "gradient",
                colors: [color1, color2],
                gradient: {
                    shade: "light",
                    type: "vertical",
                    shadeIntensity: 0.5,
                    gradientToColors: [undefined, `${color2}00`],
                    inverseColors: false,
                    opacityFrom: [0.4, 0.4, 0.15], // 👈 yellow reduced
                    opacityTo: [0.3, 0.3, 0.05], // 👈 yellow reduced
                    stops: [0, 100],
                },
            },
            markers: {
                colors: [color1, color2],
                strokeWidth: 3,
                size: 0,
                hover: { size: 10 },
            },
            xaxis: {
                categories: xAxisLabels.length ? xAxisLabels : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // dynamic labels
                tooltip: { enabled: false },
                labels: { formatter: (value) => value, style: { fontSize: "14px" }, rotate: -90, },
            },
            yaxis: {
                labels: { formatter: (value) =>value, style: { fontSize: "14px" } },
            },
            tooltip: {
                x: { format: "dd/MM/yy HH:mm" },
            },
        };

        return (
            <ReactApexChart
                options={options}
                series={series}
                type='area'
                height={270}

            />
        );
    };


    return {
        createChart,
        createChartTwo,
        createChartSix
    }

};

export default useDashboardApexChart;
